<template>
  <div class="row">
    <div class="col-12 mt-3">
      <div class="form row">
        <div class="form-group col-md-6 col-12">
          <label :class="{ 'text-light': isNew }" for="password"
            >Wachtwoord</label
          >
          <input
            id="password"
            v-model="item.password"
            placeholder="Wachtwoord"
            class="form-control"
            type="password"
            @input="_isValidPassword()"
          />
        </div>

        <div class="form-group col-md-6 col-12">
          <label :class="{ 'text-light': isNew }" for="repassword"
            >Wachtwoord controle</label
          >
          <input
            id="repassword"
            v-model="item.repassword"
            placeholder="Wachtwoord controle"
            class="form-control"
            type="password"
            @input="_isPasswordMatch()"
          />
          <span
            class="text-danger"
            style="font-size: 14px"
            v-if="rpwd_error != ''"
          >
            {{ rpwd_error }}
          </span>
        </div>
        <div class="col-12" v-if="passwordReset">
          Wachtwoord : {{ item.password }}
        </div>
      </div>
    </div>
    <div class="col-12 pl-0">
      <div class="alert-alert-danger">
        <p style="color: red; text-align: center">{{ error }}</p>
      </div>
      <div class="errors ml-0 pl-0">
        <ul :class="{ 'text-light': isNew }">
          <li :class="{ validated: validate_errors.mininum }">
            Minimaal 6 karakters (a-z)
          </li>
          <li :class="{ validated: validate_errors.capital }">
            Minimaal 1 hoofletter (A-Z)
          </li>
          <li :class="{ validated: validate_errors.number }">
            Minimaal 1 cijfer (0-9)
          </li>
          <li :class="{ validated: validate_errors.symbol }">
            Minimaal 1 symbool (*)
          </li>
          <li :class="{ validated: validate_errors.p_match }">
            Wachtwoord komt overeen
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    passwordReset: {
      required: true,
      type: Boolean,
    },
    error: {
      required: true,
      type: String,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      edit: true,
      rpwd_error: "",
      validate_errors: {
        mininum: false,
        capital: false,
        number: false,
        symbol: false,
        match: false,
      },
    };
  },

  computed: {
    item: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isCurrentUserProfile() {
      return this.$store.state.auth.user.id == this.$route.params.id;
    },
    canEditPassword() {
      return (
        !this.isCurrentUserProfile &&
        this.userHasRoles(["Super-Admin", "Admin", "Ledenadministratie"])
      );
    },
  },

  methods: {
    _isValidPassword() {
      let isvalid = true;

      if (this.item.password.length >= 6) {
        this.validate_errors.mininum = true;
      } else {
        this.validate_errors.mininum = false;
        isvalid = false;
      }

      // eslint-disable-next-line
      let format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      if (format.test(this.item.password)) {
        this.validate_errors.symbol = true;
      } else {
        this.validate_errors.symbol = false;
        isvalid = false;
      }

      if (/[A-Z]/.test(this.item.password)) {
        this.validate_errors.capital = true;
      } else {
        this.validate_errors.capital = false;
        isvalid = false;
      }

      if (/\d/.test(this.item.password)) {
        this.validate_errors.number = true;
      } else {
        this.validate_errors.number = false;
        isvalid = false;
      }

      this.$parent.isValidPassword = isvalid;
      this._isPasswordMatch();
    },

    _isPasswordMatch() {
      let isvalid = true;
      if (
        this.item.password.length > 5 &&
        this.item.repassword === this.item.password
      ) {
        this.validate_errors.p_match = true;
      } else {
        this.validate_errors.p_match = false;
        isvalid = false;
      }
      this.$parent.isPasswordMatch = isvalid;
    },
  },

  created() {
    this._isPasswordMatch();
    this._isValidPassword();
    this.edit = this.$route.params.id == this.$store.state.auth.user.id;
  },
};
</script>
